import Field from '../Field'

export default class extends Field {
  static name = 'boolean'

  mutator (value) {
    return !!value
  }
}
